import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["btn", "msg"]

  async submit(event) {
    event.preventDefault()
    const form = event.currentTarget

    if (this.hasBtnTarget) {
      this.btnTarget.disabled = true
      this.btnTarget.style.opacity = "0.6"
    }

    const data = new FormData(form)

    try {
      const response = await fetch(form.action, {
        method: "POST",
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: data
      })
      const json = await response.json()

      if (this.hasMsgTarget) {
        this.msgTarget.textContent = json.success || json.error || ""
        this.msgTarget.style.color = json.success ? "var(--page-color-muted)" : "#e53e3e"
      }

      if (json.success) {
        form.reset()
      } else if (this.hasBtnTarget) {
        this.btnTarget.disabled = false
        this.btnTarget.style.opacity = ""
      }
    } catch {
      if (this.hasMsgTarget) {
        this.msgTarget.textContent = "Ein Fehler ist aufgetreten. Bitte erneut versuchen."
        this.msgTarget.style.color = "#e53e3e"
      }
      if (this.hasBtnTarget) {
        this.btnTarget.disabled = false
        this.btnTarget.style.opacity = ""
      }
    }
  }
}
